export type AverageResponseType = Record<string, { rate: string; count: string }[]>;

export type ReviewResponseType = {
    rewarded_review: string;
    count_helpful_yes: string;
    firstname: string;
    description: string;
    order_ref: string;
    rate: string;
    review: string;
    email: string;
    product_review_recommandation_ami: string;
    product_review_temps_utilisation: string;
    info10: string;
    count_helpful_no: string;
    hide_personnal_data: string;
    product_review_design: string;
    url_product: string;
    brand_name: string;
    product_review_facilite_installation: string;
    lastname: string;
    info9: string;
    info8: string;
    order_date: string;
    product_review_qualite_produit: string;
    medias: string;
    info7: string;
    id_review_product: string;
    review_date: string;
    info6: string;
    id_product: string;
    brand_review_age: string;
    product_review_facilitedutilisation: string;
    product_review_recommandation_telephone: string;
    info1: string;
    product_review_autonomie: string;
    id_review: string;
    product_review_title: string;
    info5: string;
    category: string;
    sign_helpful: string;
    info4: string;
    publish_date: string;
    info3: string;
    info2: string;
    product_review_qualite_appareil2: string;
    product_review_profil: string;
    product_review_sexe: string;
};

export type ReviewsResponseType = {
    reviews: ReviewResponseType[];
}[];

export type ReviewAverageType = { gencode: string; rate: number; count: number };

export enum ReviewUserGender {
    MALE = 'Homme',
    FEMALE = 'Femme',
}

export type ReviewUser = {
    login: string;
    gender?: ReviewUserGender;
    ageLabel: string;
    isVerified: boolean;
};

export type ReviewType = {
    note: number;
    title: string;
    shortMessage: string;
    message: string;
    created_at: Date;
    user: ReviewUser;
    isRecommended: boolean;
    syndication: {
        image: string;
        name: string;
    };
    recommendedFor: string;
    pros?: string;
    cons?: string;
};

export type ReviewsInfoType = {
    note: number;
    reviewCount: number;
    averages: Record<string, { label: string; note: number }>;
    reviews: ReviewType[];
};

// ============================================
// Skeepers API v2 Response Types
// ============================================

/**
 * Response item from GET /products/ratings
 */
export type SkeepersRatingResponse = {
    product_variation_id?: string;
    product_ean?: string;
    average: number;
    count_total: number;
    count_5: number;
    count_4: number;
    count_3: number;
    count_2: number;
    count_1: number;
    extras?: SkeepersExtrasItem[];
};

/**
 * Extra field item from Skeepers API v2
 * Note: For ratings, it has average/count/label
 * For reviews, it has label/value/display_name
 */
export type SkeepersExtrasItem = {
    key?: string;
    label: string;
    value?: string | number;
    average?: number;
    count?: number;
    type?: string;
    display_name?: string;
    published?: string;
};

/**
 * Media item from Skeepers API v2
 */
export type SkeepersMediaItem = {
    type: 'image' | 'video';
    url: string;
    thumbnail_url?: string;
};

/**
 * Moderation item from Skeepers API v2
 */
export type SkeepersModeration = {
    type: string;
    content: string;
    date: string;
};

/**
 * Response item from GET /products/reviews
 */
export type SkeepersReviewResponse = {
    review_id: string;
    author_firstname: string;
    author_lastname?: string;
    is_personal_data_disclosed: boolean;
    locale: string;
    review_date: string;
    review_content: string;
    review_rate: number;
    publish_date: string;
    order_date?: string;
    order_reference?: string;
    product_variation_id: string;
    product_ean?: string;
    product_upc?: string;
    product_jan?: string;
    product_sku?: string;
    product_mpn?: string;
    product_brand?: string;
    product_name?: string;
    product_page_url?: string;
    order_id?: string;
    is_verified: boolean;
    medias?: SkeepersMediaItem[];
    incentivization?: 'none' | 'gifted' | 'compensated' | 'spontaneous';
    syndicated_review?: boolean;
    syndicated_review_source?: string;
    syndicated_review_source_url?: string;
    translated_review?: {
        locale: string;
        content: string;
    };
    moderations?: SkeepersModeration[];
    extras?: Record<string, SkeepersExtrasItem>;
};
